// Somewhat based on:
// <https://github.com/defunctzombie/node-process/blob/master/browser.js>.
// But I don’t think one tiny line of code can be copyrighted. 😅
export var proc = {
  cwd: cwd
};

function cwd() {
  return '/';
}